import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

interface CancelSubscriptionResponse {
  success: boolean;
  message: string;
}

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();

  const cancelSubscription = async (
    subscriptionId: number
  ): Promise<CancelSubscriptionResponse> => {
    const response = await Axios.delete<CancelSubscriptionResponse>(
      `${DELETE_URL(subscriptionId.toString()).deleteSubscription}`
    );
    // Handle 204 No Content response
    if (response.status === 204) {
      return { success: true, message: 'Subscription cancelled successfully' };
    }
    return response.data;
  };

  return useMutation<CancelSubscriptionResponse, AxiosError<BaseError>, number>(
    cancelSubscription,
    {
      onSuccess: (_, subscriptionId) => {
        queryClient.invalidateQueries('subscriptionPlans');
        queryClient.invalidateQueries([
          'subscription',
          subscriptionId.toString()
        ]);
      },
      useErrorBoundary: false
    }
  );
};
